<template>
	<v-container fluid>
		<v-row>
			<v-col
				cols="12"
				sm="8"
				class="mx-auto"
			>
				<v-sheet class="pa-2">
					<h1>Привет, <span class="green--text">{{ user.name }}</span>!</h1>
				</v-sheet>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const STORE_AUTH = createNamespacedHelpers('auth');

export default {
	name: 'Dashboard',
	computed: {
		...STORE_AUTH.mapState([ 'user' ]),
	},
}
</script>
